import {
  RESET_DASHBOARD_DATA,
  CHANGE_DASHBOARD_DATA,
  CHANGE_DASHBOARD_EXPORTING,
  CHANGE_DASHBOARD_DIFFERENCE_MEDIAN,
  CHANGE_DASHBOARD_PERCENTAGE_MEDIAN
} from './actions'

const initialState = {
  data: {
    'first': {
      'chart': [],
      'dynamic': {},
      'static': {
        'average_answer_time': {}
      }
    },
    'second': [],
    'third': [],
    'fourth': [],
    'fifth': []
  },
  exporting: false,
  differenceMedian: 0,
  percentageMedian: 0
}

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_DASHBOARD_DATA:
      const { data, block } = action.payload

      if (block) { return { ...state, data: { ...state.data, [block]: data } } }

      return { ...state, data }
    case CHANGE_DASHBOARD_EXPORTING:
      return { ...state, exporting: action.payload }
    case CHANGE_DASHBOARD_DIFFERENCE_MEDIAN:
      return { ...state, differenceMedian: action.payload }
    case CHANGE_DASHBOARD_PERCENTAGE_MEDIAN:
      return { ...state, percentageMedian: action.payload }
    case RESET_DASHBOARD_DATA:
      return { ...initialState }
    default:
      return state
  }
}
